//----------------------------------------------------------------------------
// THIS IS A GENERATED REACT ICON COMPONENT. DO NOT EDIT MANUALLY AT ANY COST!
//----------------------------------------------------------------------------;

import type { IconProps } from "../../types/icon";
import { IconWrapper } from "../IconWrapper";

export const Filter = (allProps: IconProps) => {
  const { svgProps: props, ...restProps } = allProps;
  return (
    <IconWrapper
      componentName="Filter"
      icon={
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <g clipPath="url(#prefix__clip0_21705_3238)">
            <path
              d="M15.343 7.79287e-05H0.656906C0.137931 7.79287e-05 -0.175234 0.533346 0.105147 0.939381L5.2546 8.38142C5.32264 8.47969 5.35872 8.59473 5.35872 8.71128V13.0589C5.35872 13.2753 5.48169 13.4748 5.68174 13.5845L9.94486 15.9149C10.3827 16.1541 10.9336 15.8608 10.9336 15.3892V8.70289C10.9336 8.59091 10.9664 8.48197 11.0287 8.38674L15.9036 0.925593C16.1692 0.519558 15.8544 0 15.3428 0L15.343 7.79287e-05Z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id="prefix__clip0_21705_3238">
              <rect width={16} height={16} fill="white" />
            </clipPath>
          </defs>
        </svg>
      }
      {...restProps}
    />
  );
};
